/* eslint-disable no-console */
import { takeLatest, put } from 'redux-saga/effects';
import * as TypeActions from '../store/pedidoVoo/actionsTypes';
import BaseService from '../services/BaseService';
import FileService from '../services/FileService';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import * as LoaderTypeActions from '../store/loader/actionsTypes';

function* findById({ id }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });

    const response = yield BaseService.get({ url: `pedidos-voo/${id}` });
    if (response.data && response.data.arquivos && response.data.arquivos.length > 0) {
      response.data.arquivos = yield FileService.downloadArquivos(response.data.arquivos);
    }

    yield put({
      type: TypeActions.PEDIDO_VOO_FIND_ONE_SUCCESS,
      data: response.data,
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao carregar as informações!',
    });
  }
}

function* findArquivosById({ id, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });

    const response = yield BaseService.get({ url: `pedidos-voo/${id}` });
    let arquivos = response.data?.arquivos || [];
    if (arquivos.length > 0) {
      arquivos = yield FileService.downloadArquivos(arquivos);
    }

    if (callback) yield callback(arquivos);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao carregar os arquivos!',
    });
  }
}

function* save({ data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });

    const response = yield BaseService.post({
      url: 'pedidos-voo',
      data: { ...data, arquivos: FileService.getArquivosToUpload(data.arquivos) },
    });
    if (response.data && response.data.arquivos) {
      yield FileService.uploadArquivos(data.arquivos, response.data.arquivos);
    }

    yield put({
      type: TypeActions.PEDIDO_VOO_SAVE_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(true, response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações salvas com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    let message = 'Erro ao salvar as informações!';
    if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message,
    });
  }
}

function* update({ id, data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });

    const response = yield BaseService.put({
      url: `pedidos-voo/${id}`,
      data: { ...data, arquivos: FileService.getArquivosToUpload(data.arquivos) },
    });
    if (response.data && response.data.arquivos) {
      yield FileService.uploadArquivos(data.arquivos, response.data.arquivos);
    }

    yield put({
      type: TypeActions.PEDIDO_VOO_UPDATE_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(true, response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações atualizadas com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    let message = 'Erro ao atualizar as informações!';
    if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message,
    });
  }
}

function* validate({ id, data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });

    const response = yield BaseService.patch({
      url: `pedidos-voo/${id}/validate`,
      data,
    });

    yield put({
      type: TypeActions.PEDIDO_VOO_VALIDATE_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(true, response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Pedido de voo atualizado com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    let message = 'Erro ao validar o pedido de voo!';
    if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message,
    });
  }
}

function* deleteById({ id, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    yield BaseService.delete({ url: `pedidos-voo/${id}` });
    yield put({
      type: TypeActions.PEDIDO_VOO_DELETE_SUCCESS,
      id,
    });
    if (callback) yield callback(true);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Pedido de voo removido com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    let message = 'Erro ao remover o pedido de voo!';
    if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message,
    });
  }
}

export default function* watchPedidoVoo() {
  yield takeLatest(TypeActions.PEDIDO_VOO_FIND_ONE, findById);
  yield takeLatest(TypeActions.PEDIDO_VOO_FIND_ARQUIVOS, findArquivosById);
  yield takeLatest(TypeActions.PEDIDO_VOO_SAVE, save);
  yield takeLatest(TypeActions.PEDIDO_VOO_UPDATE, update);
  yield takeLatest(TypeActions.PEDIDO_VOO_VALIDATE, validate);
  yield takeLatest(TypeActions.PEDIDO_VOO_DELETE, deleteById);
}
